import { toast } from "react-toastify";
import Notification from "../components/Notification/Notification";
import useStyles from "../themes/style";

const positions = [toast.POSITION.TOP_RIGHT];

let errorToastId = null; // Track error notifications to avoid duplicates

export const useNotification = () => {
  const classes = useStyles();

  const handleNotificationCall = (notificationType, message) => {
    if (errorToastId && notificationType === "error") return;

    // Define componentProps based on notificationType
    const componentProps = {
      type:
        notificationType === "info"
          ? "feedback"
          : notificationType === "error"
          ? "message"
          : "shipped",
      message,
      variant: "contained",
      color:
        notificationType === "info"
          ? "primary"
          : notificationType === "error"
          ? "secondary"
          : "success",
    };

    // Send notification using react-toastify
    const toastId = toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      {
        type: notificationType,
        position: positions[0], // Static position
        progressClassName: classes.progress,
        onClose: notificationType === "error" && (() => (errorToastId = null)),
        className: classes.notification,
      },
    );

    if (notificationType === "error") errorToastId = toastId;
  };

  return handleNotificationCall;
};
